/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as NoAccessRouteImport } from './routes/no-access'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedUsersRouteImport } from './routes/_authenticated/users'
import { Route as AuthenticatedTimesheetsRouteImport } from './routes/_authenticated/timesheets'
import { Route as AuthenticatedSetupRouteImport } from './routes/_authenticated/setup'
import { Route as AuthenticatedReportsRouteImport } from './routes/_authenticated/reports'
import { Route as AuthenticatedInvoicesRouteImport } from './routes/_authenticated/invoices'
import { Route as AuthenticatedGuidesAndUpdatesRouteImport } from './routes/_authenticated/guides-and-updates'
import { Route as AuthenticatedDashboardsRouteImport } from './routes/_authenticated/dashboards'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedCustomersRouteImport } from './routes/_authenticated/customers'
import { Route as AuthenticatedAuditRouteImport } from './routes/_authenticated/audit'
import { Route as AuthenticatedApprovalsRouteImport } from './routes/_authenticated/approvals'
import { Route as AuthenticatedUsersIndexRouteImport } from './routes/_authenticated/users.index'
import { Route as AuthenticatedTimesheetsIndexRouteImport } from './routes/_authenticated/timesheets.index'
import { Route as AuthenticatedSetupIndexRouteImport } from './routes/_authenticated/setup.index'
import { Route as AuthenticatedReportsIndexRouteImport } from './routes/_authenticated/reports.index'
import { Route as AuthenticatedNotificationsIndexRouteImport } from './routes/_authenticated/notifications.index'
import { Route as AuthenticatedInvoicesIndexRouteImport } from './routes/_authenticated/invoices.index'
import { Route as AuthenticatedDashboardsIndexRouteImport } from './routes/_authenticated/dashboards.index'
import { Route as AuthenticatedDashboardIndexRouteImport } from './routes/_authenticated/dashboard.index'
import { Route as AuthenticatedCustomersIndexRouteImport } from './routes/_authenticated/customers.index'
import { Route as AuthenticatedUsersNewRouteImport } from './routes/_authenticated/users.new'
import { Route as AuthenticatedUsersIdRouteImport } from './routes/_authenticated/users.$id'
import { Route as AuthenticatedTimesheetsSettingsRouteImport } from './routes/_authenticated/timesheets.settings'
import { Route as AuthenticatedSetupSystemRolesRouteImport } from './routes/_authenticated/setup.system-roles'
import { Route as AuthenticatedSetupSkillsRouteImport } from './routes/_authenticated/setup.skills'
import { Route as AuthenticatedSetupServiceRolesRouteImport } from './routes/_authenticated/setup.service-roles'
import { Route as AuthenticatedSetupRatecardsRouteImport } from './routes/_authenticated/setup.ratecards'
import { Route as AuthenticatedSetupNotificationsRouteImport } from './routes/_authenticated/setup.notifications'
import { Route as AuthenticatedSetupHolidaysRouteImport } from './routes/_authenticated/setup.holidays'
import { Route as AuthenticatedSetupExpenseCatalogsRouteImport } from './routes/_authenticated/setup.expense-catalogs'
import { Route as AuthenticatedSetupDepartmentsRouteImport } from './routes/_authenticated/setup.departments'
import { Route as AuthenticatedSetupCustomFieldsRouteImport } from './routes/_authenticated/setup.custom-fields'
import { Route as AuthenticatedSetupCompanyRouteImport } from './routes/_authenticated/setup.company'
import { Route as AuthenticatedSetupChartOfAccountsRouteImport } from './routes/_authenticated/setup.chart-of-accounts'
import { Route as AuthenticatedSetupBusinessUnitsRouteImport } from './routes/_authenticated/setup.business-units'
import { Route as AuthenticatedSetupActivitiesRouteImport } from './routes/_authenticated/setup.activities'
import { Route as AuthenticatedReportsTimesheetsRouteImport } from './routes/_authenticated/reports.timesheets'
import { Route as AuthenticatedReportsNewRouteImport } from './routes/_authenticated/reports.new'
import { Route as AuthenticatedNotificationsIdRouteImport } from './routes/_authenticated/notifications.$id'
import { Route as AuthenticatedInvoicesVariableExpensesRouteImport } from './routes/_authenticated/invoices.variable-expenses'
import { Route as AuthenticatedInvoicesSettingsRouteImport } from './routes/_authenticated/invoices.settings'
import { Route as AuthenticatedInvoicesNewRouteImport } from './routes/_authenticated/invoices.new'
import { Route as AuthenticatedInvoicesIdRouteImport } from './routes/_authenticated/invoices.$id'
import { Route as AuthenticatedDashboardsDashboardIdRouteImport } from './routes/_authenticated/dashboards.$dashboardId'
import { Route as AuthenticatedDashboardDashboardIdRouteImport } from './routes/_authenticated/dashboard.$dashboardId'
import { Route as AuthenticatedCustomersIdRouteImport } from './routes/_authenticated/customers.$id'
import { Route as AuthenticatedUsersIdIndexRouteImport } from './routes/_authenticated/users.$id.index'
import { Route as AuthenticatedSetupSystemRolesIndexRouteImport } from './routes/_authenticated/setup.system-roles.index'
import { Route as AuthenticatedSetupServiceRolesIndexRouteImport } from './routes/_authenticated/setup.service-roles.index'
import { Route as AuthenticatedSetupRatecardsIndexRouteImport } from './routes/_authenticated/setup.ratecards.index'
import { Route as AuthenticatedSetupExpenseCatalogsIndexRouteImport } from './routes/_authenticated/setup.expense-catalogs.index'
import { Route as AuthenticatedSetupDepartmentsIndexRouteImport } from './routes/_authenticated/setup.departments.index'
import { Route as AuthenticatedSetupBusinessUnitsIndexRouteImport } from './routes/_authenticated/setup.business-units.index'
import { Route as AuthenticatedSetupApprovalPoliciesIndexRouteImport } from './routes/_authenticated/setup.approval-policies.index'
import { Route as AuthenticatedSetupActivitiesIndexRouteImport } from './routes/_authenticated/setup.activities.index'
import { Route as AuthenticatedInvoicesRunsIndexRouteImport } from './routes/_authenticated/invoices.runs.index'
import { Route as AuthenticatedCustomersIdIndexRouteImport } from './routes/_authenticated/customers.$id.index'
import { Route as AuthenticatedUsersIdEditRouteImport } from './routes/_authenticated/users.$id.edit'
import { Route as AuthenticatedSetupSystemRolesIdRouteImport } from './routes/_authenticated/setup.system-roles.$id'
import { Route as AuthenticatedSetupRatecardsIdRouteImport } from './routes/_authenticated/setup.ratecards.$id'
import { Route as AuthenticatedSetupExpenseCatalogsIdRouteImport } from './routes/_authenticated/setup.expense-catalogs.$id'
import { Route as AuthenticatedSetupDepartmentsIdRouteImport } from './routes/_authenticated/setup.departments.$id'
import { Route as AuthenticatedSetupBusinessUnitsIdRouteImport } from './routes/_authenticated/setup.business-units.$id'
import { Route as AuthenticatedSetupActivitiesIdRouteImport } from './routes/_authenticated/setup.activities.$id'
import { Route as AuthenticatedReportsCustomReportIdRouteImport } from './routes/_authenticated/reports.custom.$reportId'
import { Route as AuthenticatedInvoicesRunsRunIdRouteImport } from './routes/_authenticated/invoices.runs.$runId'
import { Route as AuthenticatedCustomersIdEditRouteImport } from './routes/_authenticated/customers.$id.edit'
import { Route as AuthenticatedSetupSystemRolesIdIndexRouteImport } from './routes/_authenticated/setup.system-roles.$id.index'
import { Route as AuthenticatedSetupServiceRolesIdIndexRouteImport } from './routes/_authenticated/setup.service-roles.$id.index'
import { Route as AuthenticatedSetupExpenseCatalogsIdIndexRouteImport } from './routes/_authenticated/setup.expense-catalogs.$id.index'
import { Route as AuthenticatedSetupDepartmentsIdIndexRouteImport } from './routes/_authenticated/setup.departments.$id.index'
import { Route as AuthenticatedSetupActivitiesIdIndexRouteImport } from './routes/_authenticated/setup.activities.$id.index'
import { Route as AuthenticatedCustomersIdSowsSowIdRouteImport } from './routes/_authenticated/customers.$id.sows.$sowId'
import { Route as AuthenticatedCustomersIdEngagementsEngagementIdRouteImport } from './routes/_authenticated/customers.$id.engagements.$engagementId'

const NoAccessRoute = NoAccessRouteImport.update({
  id: '/no-access',
  path: '/no-access',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedUsersRoute = AuthenticatedUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedTimesheetsRoute = AuthenticatedTimesheetsRouteImport.update({
  id: '/timesheets',
  path: '/timesheets',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSetupRoute = AuthenticatedSetupRouteImport.update({
  id: '/setup',
  path: '/setup',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedReportsRoute = AuthenticatedReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedInvoicesRoute = AuthenticatedInvoicesRouteImport.update({
  id: '/invoices',
  path: '/invoices',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedGuidesAndUpdatesRoute =
  AuthenticatedGuidesAndUpdatesRouteImport.update({
    id: '/guides-and-updates',
    path: '/guides-and-updates',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDashboardsRoute = AuthenticatedDashboardsRouteImport.update({
  id: '/dashboards',
  path: '/dashboards',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedCustomersRoute = AuthenticatedCustomersRouteImport.update({
  id: '/customers',
  path: '/customers',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAuditRoute = AuthenticatedAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedApprovalsRoute = AuthenticatedApprovalsRouteImport.update({
  id: '/approvals',
  path: '/approvals',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedUsersIndexRoute = AuthenticatedUsersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedUsersRoute,
} as any)
const AuthenticatedTimesheetsIndexRoute =
  AuthenticatedTimesheetsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedTimesheetsRoute,
  } as any)
const AuthenticatedSetupIndexRoute = AuthenticatedSetupIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedSetupRoute,
} as any)
const AuthenticatedReportsIndexRoute =
  AuthenticatedReportsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedNotificationsIndexRoute =
  AuthenticatedNotificationsIndexRouteImport.update({
    id: '/notifications/',
    path: '/notifications/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInvoicesIndexRoute =
  AuthenticatedInvoicesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedInvoicesRoute,
  } as any)
const AuthenticatedDashboardsIndexRoute =
  AuthenticatedDashboardsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedDashboardsRoute,
  } as any)
const AuthenticatedDashboardIndexRoute =
  AuthenticatedDashboardIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedCustomersIndexRoute =
  AuthenticatedCustomersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedCustomersRoute,
  } as any)
const AuthenticatedUsersNewRoute = AuthenticatedUsersNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthenticatedUsersRoute,
} as any)
const AuthenticatedUsersIdRoute = AuthenticatedUsersIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AuthenticatedUsersRoute,
} as any)
const AuthenticatedTimesheetsSettingsRoute =
  AuthenticatedTimesheetsSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedTimesheetsRoute,
  } as any)
const AuthenticatedSetupSystemRolesRoute =
  AuthenticatedSetupSystemRolesRouteImport.update({
    id: '/system-roles',
    path: '/system-roles',
    getParentRoute: () => AuthenticatedSetupRoute,
  } as any)
const AuthenticatedSetupSkillsRoute =
  AuthenticatedSetupSkillsRouteImport.update({
    id: '/skills',
    path: '/skills',
    getParentRoute: () => AuthenticatedSetupRoute,
  } as any)
const AuthenticatedSetupServiceRolesRoute =
  AuthenticatedSetupServiceRolesRouteImport.update({
    id: '/service-roles',
    path: '/service-roles',
    getParentRoute: () => AuthenticatedSetupRoute,
  } as any)
const AuthenticatedSetupRatecardsRoute =
  AuthenticatedSetupRatecardsRouteImport.update({
    id: '/ratecards',
    path: '/ratecards',
    getParentRoute: () => AuthenticatedSetupRoute,
  } as any)
const AuthenticatedSetupNotificationsRoute =
  AuthenticatedSetupNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthenticatedSetupRoute,
  } as any)
const AuthenticatedSetupHolidaysRoute =
  AuthenticatedSetupHolidaysRouteImport.update({
    id: '/holidays',
    path: '/holidays',
    getParentRoute: () => AuthenticatedSetupRoute,
  } as any)
const AuthenticatedSetupExpenseCatalogsRoute =
  AuthenticatedSetupExpenseCatalogsRouteImport.update({
    id: '/expense-catalogs',
    path: '/expense-catalogs',
    getParentRoute: () => AuthenticatedSetupRoute,
  } as any)
const AuthenticatedSetupDepartmentsRoute =
  AuthenticatedSetupDepartmentsRouteImport.update({
    id: '/departments',
    path: '/departments',
    getParentRoute: () => AuthenticatedSetupRoute,
  } as any)
const AuthenticatedSetupCustomFieldsRoute =
  AuthenticatedSetupCustomFieldsRouteImport.update({
    id: '/custom-fields',
    path: '/custom-fields',
    getParentRoute: () => AuthenticatedSetupRoute,
  } as any)
const AuthenticatedSetupCompanyRoute =
  AuthenticatedSetupCompanyRouteImport.update({
    id: '/company',
    path: '/company',
    getParentRoute: () => AuthenticatedSetupRoute,
  } as any)
const AuthenticatedSetupChartOfAccountsRoute =
  AuthenticatedSetupChartOfAccountsRouteImport.update({
    id: '/chart-of-accounts',
    path: '/chart-of-accounts',
    getParentRoute: () => AuthenticatedSetupRoute,
  } as any)
const AuthenticatedSetupBusinessUnitsRoute =
  AuthenticatedSetupBusinessUnitsRouteImport.update({
    id: '/business-units',
    path: '/business-units',
    getParentRoute: () => AuthenticatedSetupRoute,
  } as any)
const AuthenticatedSetupActivitiesRoute =
  AuthenticatedSetupActivitiesRouteImport.update({
    id: '/activities',
    path: '/activities',
    getParentRoute: () => AuthenticatedSetupRoute,
  } as any)
const AuthenticatedReportsTimesheetsRoute =
  AuthenticatedReportsTimesheetsRouteImport.update({
    id: '/timesheets',
    path: '/timesheets',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsNewRoute = AuthenticatedReportsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthenticatedReportsRoute,
} as any)
const AuthenticatedNotificationsIdRoute =
  AuthenticatedNotificationsIdRouteImport.update({
    id: '/notifications/$id',
    path: '/notifications/$id',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInvoicesVariableExpensesRoute =
  AuthenticatedInvoicesVariableExpensesRouteImport.update({
    id: '/variable-expenses',
    path: '/variable-expenses',
    getParentRoute: () => AuthenticatedInvoicesRoute,
  } as any)
const AuthenticatedInvoicesSettingsRoute =
  AuthenticatedInvoicesSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedInvoicesRoute,
  } as any)
const AuthenticatedInvoicesNewRoute =
  AuthenticatedInvoicesNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedInvoicesRoute,
  } as any)
const AuthenticatedInvoicesIdRoute = AuthenticatedInvoicesIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AuthenticatedInvoicesRoute,
} as any)
const AuthenticatedDashboardsDashboardIdRoute =
  AuthenticatedDashboardsDashboardIdRouteImport.update({
    id: '/$dashboardId',
    path: '/$dashboardId',
    getParentRoute: () => AuthenticatedDashboardsRoute,
  } as any)
const AuthenticatedDashboardDashboardIdRoute =
  AuthenticatedDashboardDashboardIdRouteImport.update({
    id: '/$dashboardId',
    path: '/$dashboardId',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedCustomersIdRoute =
  AuthenticatedCustomersIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthenticatedCustomersRoute,
  } as any)
const AuthenticatedUsersIdIndexRoute =
  AuthenticatedUsersIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedUsersIdRoute,
  } as any)
const AuthenticatedSetupSystemRolesIndexRoute =
  AuthenticatedSetupSystemRolesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSetupSystemRolesRoute,
  } as any)
const AuthenticatedSetupServiceRolesIndexRoute =
  AuthenticatedSetupServiceRolesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSetupServiceRolesRoute,
  } as any)
const AuthenticatedSetupRatecardsIndexRoute =
  AuthenticatedSetupRatecardsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSetupRatecardsRoute,
  } as any)
const AuthenticatedSetupExpenseCatalogsIndexRoute =
  AuthenticatedSetupExpenseCatalogsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSetupExpenseCatalogsRoute,
  } as any)
const AuthenticatedSetupDepartmentsIndexRoute =
  AuthenticatedSetupDepartmentsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSetupDepartmentsRoute,
  } as any)
const AuthenticatedSetupBusinessUnitsIndexRoute =
  AuthenticatedSetupBusinessUnitsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSetupBusinessUnitsRoute,
  } as any)
const AuthenticatedSetupApprovalPoliciesIndexRoute =
  AuthenticatedSetupApprovalPoliciesIndexRouteImport.update({
    id: '/approval-policies/',
    path: '/approval-policies/',
    getParentRoute: () => AuthenticatedSetupRoute,
  } as any)
const AuthenticatedSetupActivitiesIndexRoute =
  AuthenticatedSetupActivitiesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSetupActivitiesRoute,
  } as any)
const AuthenticatedInvoicesRunsIndexRoute =
  AuthenticatedInvoicesRunsIndexRouteImport.update({
    id: '/runs/',
    path: '/runs/',
    getParentRoute: () => AuthenticatedInvoicesRoute,
  } as any)
const AuthenticatedCustomersIdIndexRoute =
  AuthenticatedCustomersIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedCustomersIdRoute,
  } as any)
const AuthenticatedUsersIdEditRoute =
  AuthenticatedUsersIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AuthenticatedUsersIdRoute,
  } as any)
const AuthenticatedSetupSystemRolesIdRoute =
  AuthenticatedSetupSystemRolesIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthenticatedSetupSystemRolesRoute,
  } as any)
const AuthenticatedSetupRatecardsIdRoute =
  AuthenticatedSetupRatecardsIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthenticatedSetupRatecardsRoute,
  } as any)
const AuthenticatedSetupExpenseCatalogsIdRoute =
  AuthenticatedSetupExpenseCatalogsIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthenticatedSetupExpenseCatalogsRoute,
  } as any)
const AuthenticatedSetupDepartmentsIdRoute =
  AuthenticatedSetupDepartmentsIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthenticatedSetupDepartmentsRoute,
  } as any)
const AuthenticatedSetupBusinessUnitsIdRoute =
  AuthenticatedSetupBusinessUnitsIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthenticatedSetupBusinessUnitsRoute,
  } as any)
const AuthenticatedSetupActivitiesIdRoute =
  AuthenticatedSetupActivitiesIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthenticatedSetupActivitiesRoute,
  } as any)
const AuthenticatedReportsCustomReportIdRoute =
  AuthenticatedReportsCustomReportIdRouteImport.update({
    id: '/custom/$reportId',
    path: '/custom/$reportId',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedInvoicesRunsRunIdRoute =
  AuthenticatedInvoicesRunsRunIdRouteImport.update({
    id: '/runs/$runId',
    path: '/runs/$runId',
    getParentRoute: () => AuthenticatedInvoicesRoute,
  } as any)
const AuthenticatedCustomersIdEditRoute =
  AuthenticatedCustomersIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AuthenticatedCustomersIdRoute,
  } as any)
const AuthenticatedSetupSystemRolesIdIndexRoute =
  AuthenticatedSetupSystemRolesIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSetupSystemRolesIdRoute,
  } as any)
const AuthenticatedSetupServiceRolesIdIndexRoute =
  AuthenticatedSetupServiceRolesIdIndexRouteImport.update({
    id: '/$id/',
    path: '/$id/',
    getParentRoute: () => AuthenticatedSetupServiceRolesRoute,
  } as any)
const AuthenticatedSetupExpenseCatalogsIdIndexRoute =
  AuthenticatedSetupExpenseCatalogsIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSetupExpenseCatalogsIdRoute,
  } as any)
const AuthenticatedSetupDepartmentsIdIndexRoute =
  AuthenticatedSetupDepartmentsIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSetupDepartmentsIdRoute,
  } as any)
const AuthenticatedSetupActivitiesIdIndexRoute =
  AuthenticatedSetupActivitiesIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSetupActivitiesIdRoute,
  } as any)
const AuthenticatedCustomersIdSowsSowIdRoute =
  AuthenticatedCustomersIdSowsSowIdRouteImport.update({
    id: '/sows/$sowId',
    path: '/sows/$sowId',
    getParentRoute: () => AuthenticatedCustomersIdRoute,
  } as any)
const AuthenticatedCustomersIdEngagementsEngagementIdRoute =
  AuthenticatedCustomersIdEngagementsEngagementIdRouteImport.update({
    id: '/engagements/$engagementId',
    path: '/engagements/$engagementId',
    getParentRoute: () => AuthenticatedCustomersIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/no-access': typeof NoAccessRoute
  '/approvals': typeof AuthenticatedApprovalsRoute
  '/audit': typeof AuthenticatedAuditRoute
  '/customers': typeof AuthenticatedCustomersRouteWithChildren
  '/dashboard': typeof AuthenticatedDashboardRouteWithChildren
  '/dashboards': typeof AuthenticatedDashboardsRouteWithChildren
  '/guides-and-updates': typeof AuthenticatedGuidesAndUpdatesRoute
  '/invoices': typeof AuthenticatedInvoicesRouteWithChildren
  '/reports': typeof AuthenticatedReportsRouteWithChildren
  '/setup': typeof AuthenticatedSetupRouteWithChildren
  '/timesheets': typeof AuthenticatedTimesheetsRouteWithChildren
  '/users': typeof AuthenticatedUsersRouteWithChildren
  '/customers/$id': typeof AuthenticatedCustomersIdRouteWithChildren
  '/dashboard/$dashboardId': typeof AuthenticatedDashboardDashboardIdRoute
  '/dashboards/$dashboardId': typeof AuthenticatedDashboardsDashboardIdRoute
  '/invoices/$id': typeof AuthenticatedInvoicesIdRoute
  '/invoices/new': typeof AuthenticatedInvoicesNewRoute
  '/invoices/settings': typeof AuthenticatedInvoicesSettingsRoute
  '/invoices/variable-expenses': typeof AuthenticatedInvoicesVariableExpensesRoute
  '/notifications/$id': typeof AuthenticatedNotificationsIdRoute
  '/reports/new': typeof AuthenticatedReportsNewRoute
  '/reports/timesheets': typeof AuthenticatedReportsTimesheetsRoute
  '/setup/activities': typeof AuthenticatedSetupActivitiesRouteWithChildren
  '/setup/business-units': typeof AuthenticatedSetupBusinessUnitsRouteWithChildren
  '/setup/chart-of-accounts': typeof AuthenticatedSetupChartOfAccountsRoute
  '/setup/company': typeof AuthenticatedSetupCompanyRoute
  '/setup/custom-fields': typeof AuthenticatedSetupCustomFieldsRoute
  '/setup/departments': typeof AuthenticatedSetupDepartmentsRouteWithChildren
  '/setup/expense-catalogs': typeof AuthenticatedSetupExpenseCatalogsRouteWithChildren
  '/setup/holidays': typeof AuthenticatedSetupHolidaysRoute
  '/setup/notifications': typeof AuthenticatedSetupNotificationsRoute
  '/setup/ratecards': typeof AuthenticatedSetupRatecardsRouteWithChildren
  '/setup/service-roles': typeof AuthenticatedSetupServiceRolesRouteWithChildren
  '/setup/skills': typeof AuthenticatedSetupSkillsRoute
  '/setup/system-roles': typeof AuthenticatedSetupSystemRolesRouteWithChildren
  '/timesheets/settings': typeof AuthenticatedTimesheetsSettingsRoute
  '/users/$id': typeof AuthenticatedUsersIdRouteWithChildren
  '/users/new': typeof AuthenticatedUsersNewRoute
  '/customers/': typeof AuthenticatedCustomersIndexRoute
  '/dashboard/': typeof AuthenticatedDashboardIndexRoute
  '/dashboards/': typeof AuthenticatedDashboardsIndexRoute
  '/invoices/': typeof AuthenticatedInvoicesIndexRoute
  '/notifications/': typeof AuthenticatedNotificationsIndexRoute
  '/reports/': typeof AuthenticatedReportsIndexRoute
  '/setup/': typeof AuthenticatedSetupIndexRoute
  '/timesheets/': typeof AuthenticatedTimesheetsIndexRoute
  '/users/': typeof AuthenticatedUsersIndexRoute
  '/customers/$id/edit': typeof AuthenticatedCustomersIdEditRoute
  '/invoices/runs/$runId': typeof AuthenticatedInvoicesRunsRunIdRoute
  '/reports/custom/$reportId': typeof AuthenticatedReportsCustomReportIdRoute
  '/setup/activities/$id': typeof AuthenticatedSetupActivitiesIdRouteWithChildren
  '/setup/business-units/$id': typeof AuthenticatedSetupBusinessUnitsIdRoute
  '/setup/departments/$id': typeof AuthenticatedSetupDepartmentsIdRouteWithChildren
  '/setup/expense-catalogs/$id': typeof AuthenticatedSetupExpenseCatalogsIdRouteWithChildren
  '/setup/ratecards/$id': typeof AuthenticatedSetupRatecardsIdRoute
  '/setup/system-roles/$id': typeof AuthenticatedSetupSystemRolesIdRouteWithChildren
  '/users/$id/edit': typeof AuthenticatedUsersIdEditRoute
  '/customers/$id/': typeof AuthenticatedCustomersIdIndexRoute
  '/invoices/runs/': typeof AuthenticatedInvoicesRunsIndexRoute
  '/setup/activities/': typeof AuthenticatedSetupActivitiesIndexRoute
  '/setup/approval-policies/': typeof AuthenticatedSetupApprovalPoliciesIndexRoute
  '/setup/business-units/': typeof AuthenticatedSetupBusinessUnitsIndexRoute
  '/setup/departments/': typeof AuthenticatedSetupDepartmentsIndexRoute
  '/setup/expense-catalogs/': typeof AuthenticatedSetupExpenseCatalogsIndexRoute
  '/setup/ratecards/': typeof AuthenticatedSetupRatecardsIndexRoute
  '/setup/service-roles/': typeof AuthenticatedSetupServiceRolesIndexRoute
  '/setup/system-roles/': typeof AuthenticatedSetupSystemRolesIndexRoute
  '/users/$id/': typeof AuthenticatedUsersIdIndexRoute
  '/customers/$id/engagements/$engagementId': typeof AuthenticatedCustomersIdEngagementsEngagementIdRoute
  '/customers/$id/sows/$sowId': typeof AuthenticatedCustomersIdSowsSowIdRoute
  '/setup/activities/$id/': typeof AuthenticatedSetupActivitiesIdIndexRoute
  '/setup/departments/$id/': typeof AuthenticatedSetupDepartmentsIdIndexRoute
  '/setup/expense-catalogs/$id/': typeof AuthenticatedSetupExpenseCatalogsIdIndexRoute
  '/setup/service-roles/$id/': typeof AuthenticatedSetupServiceRolesIdIndexRoute
  '/setup/system-roles/$id/': typeof AuthenticatedSetupSystemRolesIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/no-access': typeof NoAccessRoute
  '/approvals': typeof AuthenticatedApprovalsRoute
  '/audit': typeof AuthenticatedAuditRoute
  '/guides-and-updates': typeof AuthenticatedGuidesAndUpdatesRoute
  '/dashboard/$dashboardId': typeof AuthenticatedDashboardDashboardIdRoute
  '/dashboards/$dashboardId': typeof AuthenticatedDashboardsDashboardIdRoute
  '/invoices/$id': typeof AuthenticatedInvoicesIdRoute
  '/invoices/new': typeof AuthenticatedInvoicesNewRoute
  '/invoices/settings': typeof AuthenticatedInvoicesSettingsRoute
  '/invoices/variable-expenses': typeof AuthenticatedInvoicesVariableExpensesRoute
  '/notifications/$id': typeof AuthenticatedNotificationsIdRoute
  '/reports/new': typeof AuthenticatedReportsNewRoute
  '/reports/timesheets': typeof AuthenticatedReportsTimesheetsRoute
  '/setup/chart-of-accounts': typeof AuthenticatedSetupChartOfAccountsRoute
  '/setup/company': typeof AuthenticatedSetupCompanyRoute
  '/setup/custom-fields': typeof AuthenticatedSetupCustomFieldsRoute
  '/setup/holidays': typeof AuthenticatedSetupHolidaysRoute
  '/setup/notifications': typeof AuthenticatedSetupNotificationsRoute
  '/setup/skills': typeof AuthenticatedSetupSkillsRoute
  '/timesheets/settings': typeof AuthenticatedTimesheetsSettingsRoute
  '/users/new': typeof AuthenticatedUsersNewRoute
  '/customers': typeof AuthenticatedCustomersIndexRoute
  '/dashboard': typeof AuthenticatedDashboardIndexRoute
  '/dashboards': typeof AuthenticatedDashboardsIndexRoute
  '/invoices': typeof AuthenticatedInvoicesIndexRoute
  '/notifications': typeof AuthenticatedNotificationsIndexRoute
  '/reports': typeof AuthenticatedReportsIndexRoute
  '/setup': typeof AuthenticatedSetupIndexRoute
  '/timesheets': typeof AuthenticatedTimesheetsIndexRoute
  '/users': typeof AuthenticatedUsersIndexRoute
  '/customers/$id/edit': typeof AuthenticatedCustomersIdEditRoute
  '/invoices/runs/$runId': typeof AuthenticatedInvoicesRunsRunIdRoute
  '/reports/custom/$reportId': typeof AuthenticatedReportsCustomReportIdRoute
  '/setup/business-units/$id': typeof AuthenticatedSetupBusinessUnitsIdRoute
  '/setup/ratecards/$id': typeof AuthenticatedSetupRatecardsIdRoute
  '/users/$id/edit': typeof AuthenticatedUsersIdEditRoute
  '/customers/$id': typeof AuthenticatedCustomersIdIndexRoute
  '/invoices/runs': typeof AuthenticatedInvoicesRunsIndexRoute
  '/setup/activities': typeof AuthenticatedSetupActivitiesIndexRoute
  '/setup/approval-policies': typeof AuthenticatedSetupApprovalPoliciesIndexRoute
  '/setup/business-units': typeof AuthenticatedSetupBusinessUnitsIndexRoute
  '/setup/departments': typeof AuthenticatedSetupDepartmentsIndexRoute
  '/setup/expense-catalogs': typeof AuthenticatedSetupExpenseCatalogsIndexRoute
  '/setup/ratecards': typeof AuthenticatedSetupRatecardsIndexRoute
  '/setup/service-roles': typeof AuthenticatedSetupServiceRolesIndexRoute
  '/setup/system-roles': typeof AuthenticatedSetupSystemRolesIndexRoute
  '/users/$id': typeof AuthenticatedUsersIdIndexRoute
  '/customers/$id/engagements/$engagementId': typeof AuthenticatedCustomersIdEngagementsEngagementIdRoute
  '/customers/$id/sows/$sowId': typeof AuthenticatedCustomersIdSowsSowIdRoute
  '/setup/activities/$id': typeof AuthenticatedSetupActivitiesIdIndexRoute
  '/setup/departments/$id': typeof AuthenticatedSetupDepartmentsIdIndexRoute
  '/setup/expense-catalogs/$id': typeof AuthenticatedSetupExpenseCatalogsIdIndexRoute
  '/setup/service-roles/$id': typeof AuthenticatedSetupServiceRolesIdIndexRoute
  '/setup/system-roles/$id': typeof AuthenticatedSetupSystemRolesIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/login': typeof LoginRoute
  '/no-access': typeof NoAccessRoute
  '/_authenticated/approvals': typeof AuthenticatedApprovalsRoute
  '/_authenticated/audit': typeof AuthenticatedAuditRoute
  '/_authenticated/customers': typeof AuthenticatedCustomersRouteWithChildren
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRouteWithChildren
  '/_authenticated/dashboards': typeof AuthenticatedDashboardsRouteWithChildren
  '/_authenticated/guides-and-updates': typeof AuthenticatedGuidesAndUpdatesRoute
  '/_authenticated/invoices': typeof AuthenticatedInvoicesRouteWithChildren
  '/_authenticated/reports': typeof AuthenticatedReportsRouteWithChildren
  '/_authenticated/setup': typeof AuthenticatedSetupRouteWithChildren
  '/_authenticated/timesheets': typeof AuthenticatedTimesheetsRouteWithChildren
  '/_authenticated/users': typeof AuthenticatedUsersRouteWithChildren
  '/_authenticated/customers/$id': typeof AuthenticatedCustomersIdRouteWithChildren
  '/_authenticated/dashboard/$dashboardId': typeof AuthenticatedDashboardDashboardIdRoute
  '/_authenticated/dashboards/$dashboardId': typeof AuthenticatedDashboardsDashboardIdRoute
  '/_authenticated/invoices/$id': typeof AuthenticatedInvoicesIdRoute
  '/_authenticated/invoices/new': typeof AuthenticatedInvoicesNewRoute
  '/_authenticated/invoices/settings': typeof AuthenticatedInvoicesSettingsRoute
  '/_authenticated/invoices/variable-expenses': typeof AuthenticatedInvoicesVariableExpensesRoute
  '/_authenticated/notifications/$id': typeof AuthenticatedNotificationsIdRoute
  '/_authenticated/reports/new': typeof AuthenticatedReportsNewRoute
  '/_authenticated/reports/timesheets': typeof AuthenticatedReportsTimesheetsRoute
  '/_authenticated/setup/activities': typeof AuthenticatedSetupActivitiesRouteWithChildren
  '/_authenticated/setup/business-units': typeof AuthenticatedSetupBusinessUnitsRouteWithChildren
  '/_authenticated/setup/chart-of-accounts': typeof AuthenticatedSetupChartOfAccountsRoute
  '/_authenticated/setup/company': typeof AuthenticatedSetupCompanyRoute
  '/_authenticated/setup/custom-fields': typeof AuthenticatedSetupCustomFieldsRoute
  '/_authenticated/setup/departments': typeof AuthenticatedSetupDepartmentsRouteWithChildren
  '/_authenticated/setup/expense-catalogs': typeof AuthenticatedSetupExpenseCatalogsRouteWithChildren
  '/_authenticated/setup/holidays': typeof AuthenticatedSetupHolidaysRoute
  '/_authenticated/setup/notifications': typeof AuthenticatedSetupNotificationsRoute
  '/_authenticated/setup/ratecards': typeof AuthenticatedSetupRatecardsRouteWithChildren
  '/_authenticated/setup/service-roles': typeof AuthenticatedSetupServiceRolesRouteWithChildren
  '/_authenticated/setup/skills': typeof AuthenticatedSetupSkillsRoute
  '/_authenticated/setup/system-roles': typeof AuthenticatedSetupSystemRolesRouteWithChildren
  '/_authenticated/timesheets/settings': typeof AuthenticatedTimesheetsSettingsRoute
  '/_authenticated/users/$id': typeof AuthenticatedUsersIdRouteWithChildren
  '/_authenticated/users/new': typeof AuthenticatedUsersNewRoute
  '/_authenticated/customers/': typeof AuthenticatedCustomersIndexRoute
  '/_authenticated/dashboard/': typeof AuthenticatedDashboardIndexRoute
  '/_authenticated/dashboards/': typeof AuthenticatedDashboardsIndexRoute
  '/_authenticated/invoices/': typeof AuthenticatedInvoicesIndexRoute
  '/_authenticated/notifications/': typeof AuthenticatedNotificationsIndexRoute
  '/_authenticated/reports/': typeof AuthenticatedReportsIndexRoute
  '/_authenticated/setup/': typeof AuthenticatedSetupIndexRoute
  '/_authenticated/timesheets/': typeof AuthenticatedTimesheetsIndexRoute
  '/_authenticated/users/': typeof AuthenticatedUsersIndexRoute
  '/_authenticated/customers/$id/edit': typeof AuthenticatedCustomersIdEditRoute
  '/_authenticated/invoices/runs/$runId': typeof AuthenticatedInvoicesRunsRunIdRoute
  '/_authenticated/reports/custom/$reportId': typeof AuthenticatedReportsCustomReportIdRoute
  '/_authenticated/setup/activities/$id': typeof AuthenticatedSetupActivitiesIdRouteWithChildren
  '/_authenticated/setup/business-units/$id': typeof AuthenticatedSetupBusinessUnitsIdRoute
  '/_authenticated/setup/departments/$id': typeof AuthenticatedSetupDepartmentsIdRouteWithChildren
  '/_authenticated/setup/expense-catalogs/$id': typeof AuthenticatedSetupExpenseCatalogsIdRouteWithChildren
  '/_authenticated/setup/ratecards/$id': typeof AuthenticatedSetupRatecardsIdRoute
  '/_authenticated/setup/system-roles/$id': typeof AuthenticatedSetupSystemRolesIdRouteWithChildren
  '/_authenticated/users/$id/edit': typeof AuthenticatedUsersIdEditRoute
  '/_authenticated/customers/$id/': typeof AuthenticatedCustomersIdIndexRoute
  '/_authenticated/invoices/runs/': typeof AuthenticatedInvoicesRunsIndexRoute
  '/_authenticated/setup/activities/': typeof AuthenticatedSetupActivitiesIndexRoute
  '/_authenticated/setup/approval-policies/': typeof AuthenticatedSetupApprovalPoliciesIndexRoute
  '/_authenticated/setup/business-units/': typeof AuthenticatedSetupBusinessUnitsIndexRoute
  '/_authenticated/setup/departments/': typeof AuthenticatedSetupDepartmentsIndexRoute
  '/_authenticated/setup/expense-catalogs/': typeof AuthenticatedSetupExpenseCatalogsIndexRoute
  '/_authenticated/setup/ratecards/': typeof AuthenticatedSetupRatecardsIndexRoute
  '/_authenticated/setup/service-roles/': typeof AuthenticatedSetupServiceRolesIndexRoute
  '/_authenticated/setup/system-roles/': typeof AuthenticatedSetupSystemRolesIndexRoute
  '/_authenticated/users/$id/': typeof AuthenticatedUsersIdIndexRoute
  '/_authenticated/customers/$id/engagements/$engagementId': typeof AuthenticatedCustomersIdEngagementsEngagementIdRoute
  '/_authenticated/customers/$id/sows/$sowId': typeof AuthenticatedCustomersIdSowsSowIdRoute
  '/_authenticated/setup/activities/$id/': typeof AuthenticatedSetupActivitiesIdIndexRoute
  '/_authenticated/setup/departments/$id/': typeof AuthenticatedSetupDepartmentsIdIndexRoute
  '/_authenticated/setup/expense-catalogs/$id/': typeof AuthenticatedSetupExpenseCatalogsIdIndexRoute
  '/_authenticated/setup/service-roles/$id/': typeof AuthenticatedSetupServiceRolesIdIndexRoute
  '/_authenticated/setup/system-roles/$id/': typeof AuthenticatedSetupSystemRolesIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/no-access'
    | '/approvals'
    | '/audit'
    | '/customers'
    | '/dashboard'
    | '/dashboards'
    | '/guides-and-updates'
    | '/invoices'
    | '/reports'
    | '/setup'
    | '/timesheets'
    | '/users'
    | '/customers/$id'
    | '/dashboard/$dashboardId'
    | '/dashboards/$dashboardId'
    | '/invoices/$id'
    | '/invoices/new'
    | '/invoices/settings'
    | '/invoices/variable-expenses'
    | '/notifications/$id'
    | '/reports/new'
    | '/reports/timesheets'
    | '/setup/activities'
    | '/setup/business-units'
    | '/setup/chart-of-accounts'
    | '/setup/company'
    | '/setup/custom-fields'
    | '/setup/departments'
    | '/setup/expense-catalogs'
    | '/setup/holidays'
    | '/setup/notifications'
    | '/setup/ratecards'
    | '/setup/service-roles'
    | '/setup/skills'
    | '/setup/system-roles'
    | '/timesheets/settings'
    | '/users/$id'
    | '/users/new'
    | '/customers/'
    | '/dashboard/'
    | '/dashboards/'
    | '/invoices/'
    | '/notifications/'
    | '/reports/'
    | '/setup/'
    | '/timesheets/'
    | '/users/'
    | '/customers/$id/edit'
    | '/invoices/runs/$runId'
    | '/reports/custom/$reportId'
    | '/setup/activities/$id'
    | '/setup/business-units/$id'
    | '/setup/departments/$id'
    | '/setup/expense-catalogs/$id'
    | '/setup/ratecards/$id'
    | '/setup/system-roles/$id'
    | '/users/$id/edit'
    | '/customers/$id/'
    | '/invoices/runs/'
    | '/setup/activities/'
    | '/setup/approval-policies/'
    | '/setup/business-units/'
    | '/setup/departments/'
    | '/setup/expense-catalogs/'
    | '/setup/ratecards/'
    | '/setup/service-roles/'
    | '/setup/system-roles/'
    | '/users/$id/'
    | '/customers/$id/engagements/$engagementId'
    | '/customers/$id/sows/$sowId'
    | '/setup/activities/$id/'
    | '/setup/departments/$id/'
    | '/setup/expense-catalogs/$id/'
    | '/setup/service-roles/$id/'
    | '/setup/system-roles/$id/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/no-access'
    | '/approvals'
    | '/audit'
    | '/guides-and-updates'
    | '/dashboard/$dashboardId'
    | '/dashboards/$dashboardId'
    | '/invoices/$id'
    | '/invoices/new'
    | '/invoices/settings'
    | '/invoices/variable-expenses'
    | '/notifications/$id'
    | '/reports/new'
    | '/reports/timesheets'
    | '/setup/chart-of-accounts'
    | '/setup/company'
    | '/setup/custom-fields'
    | '/setup/holidays'
    | '/setup/notifications'
    | '/setup/skills'
    | '/timesheets/settings'
    | '/users/new'
    | '/customers'
    | '/dashboard'
    | '/dashboards'
    | '/invoices'
    | '/notifications'
    | '/reports'
    | '/setup'
    | '/timesheets'
    | '/users'
    | '/customers/$id/edit'
    | '/invoices/runs/$runId'
    | '/reports/custom/$reportId'
    | '/setup/business-units/$id'
    | '/setup/ratecards/$id'
    | '/users/$id/edit'
    | '/customers/$id'
    | '/invoices/runs'
    | '/setup/activities'
    | '/setup/approval-policies'
    | '/setup/business-units'
    | '/setup/departments'
    | '/setup/expense-catalogs'
    | '/setup/ratecards'
    | '/setup/service-roles'
    | '/setup/system-roles'
    | '/users/$id'
    | '/customers/$id/engagements/$engagementId'
    | '/customers/$id/sows/$sowId'
    | '/setup/activities/$id'
    | '/setup/departments/$id'
    | '/setup/expense-catalogs/$id'
    | '/setup/service-roles/$id'
    | '/setup/system-roles/$id'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/login'
    | '/no-access'
    | '/_authenticated/approvals'
    | '/_authenticated/audit'
    | '/_authenticated/customers'
    | '/_authenticated/dashboard'
    | '/_authenticated/dashboards'
    | '/_authenticated/guides-and-updates'
    | '/_authenticated/invoices'
    | '/_authenticated/reports'
    | '/_authenticated/setup'
    | '/_authenticated/timesheets'
    | '/_authenticated/users'
    | '/_authenticated/customers/$id'
    | '/_authenticated/dashboard/$dashboardId'
    | '/_authenticated/dashboards/$dashboardId'
    | '/_authenticated/invoices/$id'
    | '/_authenticated/invoices/new'
    | '/_authenticated/invoices/settings'
    | '/_authenticated/invoices/variable-expenses'
    | '/_authenticated/notifications/$id'
    | '/_authenticated/reports/new'
    | '/_authenticated/reports/timesheets'
    | '/_authenticated/setup/activities'
    | '/_authenticated/setup/business-units'
    | '/_authenticated/setup/chart-of-accounts'
    | '/_authenticated/setup/company'
    | '/_authenticated/setup/custom-fields'
    | '/_authenticated/setup/departments'
    | '/_authenticated/setup/expense-catalogs'
    | '/_authenticated/setup/holidays'
    | '/_authenticated/setup/notifications'
    | '/_authenticated/setup/ratecards'
    | '/_authenticated/setup/service-roles'
    | '/_authenticated/setup/skills'
    | '/_authenticated/setup/system-roles'
    | '/_authenticated/timesheets/settings'
    | '/_authenticated/users/$id'
    | '/_authenticated/users/new'
    | '/_authenticated/customers/'
    | '/_authenticated/dashboard/'
    | '/_authenticated/dashboards/'
    | '/_authenticated/invoices/'
    | '/_authenticated/notifications/'
    | '/_authenticated/reports/'
    | '/_authenticated/setup/'
    | '/_authenticated/timesheets/'
    | '/_authenticated/users/'
    | '/_authenticated/customers/$id/edit'
    | '/_authenticated/invoices/runs/$runId'
    | '/_authenticated/reports/custom/$reportId'
    | '/_authenticated/setup/activities/$id'
    | '/_authenticated/setup/business-units/$id'
    | '/_authenticated/setup/departments/$id'
    | '/_authenticated/setup/expense-catalogs/$id'
    | '/_authenticated/setup/ratecards/$id'
    | '/_authenticated/setup/system-roles/$id'
    | '/_authenticated/users/$id/edit'
    | '/_authenticated/customers/$id/'
    | '/_authenticated/invoices/runs/'
    | '/_authenticated/setup/activities/'
    | '/_authenticated/setup/approval-policies/'
    | '/_authenticated/setup/business-units/'
    | '/_authenticated/setup/departments/'
    | '/_authenticated/setup/expense-catalogs/'
    | '/_authenticated/setup/ratecards/'
    | '/_authenticated/setup/service-roles/'
    | '/_authenticated/setup/system-roles/'
    | '/_authenticated/users/$id/'
    | '/_authenticated/customers/$id/engagements/$engagementId'
    | '/_authenticated/customers/$id/sows/$sowId'
    | '/_authenticated/setup/activities/$id/'
    | '/_authenticated/setup/departments/$id/'
    | '/_authenticated/setup/expense-catalogs/$id/'
    | '/_authenticated/setup/service-roles/$id/'
    | '/_authenticated/setup/system-roles/$id/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LoginRoute: typeof LoginRoute
  NoAccessRoute: typeof NoAccessRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/no-access': {
      id: '/no-access'
      path: '/no-access'
      fullPath: '/no-access'
      preLoaderRoute: typeof NoAccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/users': {
      id: '/_authenticated/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AuthenticatedUsersRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/timesheets': {
      id: '/_authenticated/timesheets'
      path: '/timesheets'
      fullPath: '/timesheets'
      preLoaderRoute: typeof AuthenticatedTimesheetsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/setup': {
      id: '/_authenticated/setup'
      path: '/setup'
      fullPath: '/setup'
      preLoaderRoute: typeof AuthenticatedSetupRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/reports': {
      id: '/_authenticated/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AuthenticatedReportsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/invoices': {
      id: '/_authenticated/invoices'
      path: '/invoices'
      fullPath: '/invoices'
      preLoaderRoute: typeof AuthenticatedInvoicesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/guides-and-updates': {
      id: '/_authenticated/guides-and-updates'
      path: '/guides-and-updates'
      fullPath: '/guides-and-updates'
      preLoaderRoute: typeof AuthenticatedGuidesAndUpdatesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboards': {
      id: '/_authenticated/dashboards'
      path: '/dashboards'
      fullPath: '/dashboards'
      preLoaderRoute: typeof AuthenticatedDashboardsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/customers': {
      id: '/_authenticated/customers'
      path: '/customers'
      fullPath: '/customers'
      preLoaderRoute: typeof AuthenticatedCustomersRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/audit': {
      id: '/_authenticated/audit'
      path: '/audit'
      fullPath: '/audit'
      preLoaderRoute: typeof AuthenticatedAuditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/approvals': {
      id: '/_authenticated/approvals'
      path: '/approvals'
      fullPath: '/approvals'
      preLoaderRoute: typeof AuthenticatedApprovalsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/users/': {
      id: '/_authenticated/users/'
      path: '/'
      fullPath: '/users/'
      preLoaderRoute: typeof AuthenticatedUsersIndexRouteImport
      parentRoute: typeof AuthenticatedUsersRoute
    }
    '/_authenticated/timesheets/': {
      id: '/_authenticated/timesheets/'
      path: '/'
      fullPath: '/timesheets/'
      preLoaderRoute: typeof AuthenticatedTimesheetsIndexRouteImport
      parentRoute: typeof AuthenticatedTimesheetsRoute
    }
    '/_authenticated/setup/': {
      id: '/_authenticated/setup/'
      path: '/'
      fullPath: '/setup/'
      preLoaderRoute: typeof AuthenticatedSetupIndexRouteImport
      parentRoute: typeof AuthenticatedSetupRoute
    }
    '/_authenticated/reports/': {
      id: '/_authenticated/reports/'
      path: '/'
      fullPath: '/reports/'
      preLoaderRoute: typeof AuthenticatedReportsIndexRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/notifications/': {
      id: '/_authenticated/notifications/'
      path: '/notifications'
      fullPath: '/notifications/'
      preLoaderRoute: typeof AuthenticatedNotificationsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/invoices/': {
      id: '/_authenticated/invoices/'
      path: '/'
      fullPath: '/invoices/'
      preLoaderRoute: typeof AuthenticatedInvoicesIndexRouteImport
      parentRoute: typeof AuthenticatedInvoicesRoute
    }
    '/_authenticated/dashboards/': {
      id: '/_authenticated/dashboards/'
      path: '/'
      fullPath: '/dashboards/'
      preLoaderRoute: typeof AuthenticatedDashboardsIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardsRoute
    }
    '/_authenticated/dashboard/': {
      id: '/_authenticated/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof AuthenticatedDashboardIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/customers/': {
      id: '/_authenticated/customers/'
      path: '/'
      fullPath: '/customers/'
      preLoaderRoute: typeof AuthenticatedCustomersIndexRouteImport
      parentRoute: typeof AuthenticatedCustomersRoute
    }
    '/_authenticated/users/new': {
      id: '/_authenticated/users/new'
      path: '/new'
      fullPath: '/users/new'
      preLoaderRoute: typeof AuthenticatedUsersNewRouteImport
      parentRoute: typeof AuthenticatedUsersRoute
    }
    '/_authenticated/users/$id': {
      id: '/_authenticated/users/$id'
      path: '/$id'
      fullPath: '/users/$id'
      preLoaderRoute: typeof AuthenticatedUsersIdRouteImport
      parentRoute: typeof AuthenticatedUsersRoute
    }
    '/_authenticated/timesheets/settings': {
      id: '/_authenticated/timesheets/settings'
      path: '/settings'
      fullPath: '/timesheets/settings'
      preLoaderRoute: typeof AuthenticatedTimesheetsSettingsRouteImport
      parentRoute: typeof AuthenticatedTimesheetsRoute
    }
    '/_authenticated/setup/system-roles': {
      id: '/_authenticated/setup/system-roles'
      path: '/system-roles'
      fullPath: '/setup/system-roles'
      preLoaderRoute: typeof AuthenticatedSetupSystemRolesRouteImport
      parentRoute: typeof AuthenticatedSetupRoute
    }
    '/_authenticated/setup/skills': {
      id: '/_authenticated/setup/skills'
      path: '/skills'
      fullPath: '/setup/skills'
      preLoaderRoute: typeof AuthenticatedSetupSkillsRouteImport
      parentRoute: typeof AuthenticatedSetupRoute
    }
    '/_authenticated/setup/service-roles': {
      id: '/_authenticated/setup/service-roles'
      path: '/service-roles'
      fullPath: '/setup/service-roles'
      preLoaderRoute: typeof AuthenticatedSetupServiceRolesRouteImport
      parentRoute: typeof AuthenticatedSetupRoute
    }
    '/_authenticated/setup/ratecards': {
      id: '/_authenticated/setup/ratecards'
      path: '/ratecards'
      fullPath: '/setup/ratecards'
      preLoaderRoute: typeof AuthenticatedSetupRatecardsRouteImport
      parentRoute: typeof AuthenticatedSetupRoute
    }
    '/_authenticated/setup/notifications': {
      id: '/_authenticated/setup/notifications'
      path: '/notifications'
      fullPath: '/setup/notifications'
      preLoaderRoute: typeof AuthenticatedSetupNotificationsRouteImport
      parentRoute: typeof AuthenticatedSetupRoute
    }
    '/_authenticated/setup/holidays': {
      id: '/_authenticated/setup/holidays'
      path: '/holidays'
      fullPath: '/setup/holidays'
      preLoaderRoute: typeof AuthenticatedSetupHolidaysRouteImport
      parentRoute: typeof AuthenticatedSetupRoute
    }
    '/_authenticated/setup/expense-catalogs': {
      id: '/_authenticated/setup/expense-catalogs'
      path: '/expense-catalogs'
      fullPath: '/setup/expense-catalogs'
      preLoaderRoute: typeof AuthenticatedSetupExpenseCatalogsRouteImport
      parentRoute: typeof AuthenticatedSetupRoute
    }
    '/_authenticated/setup/departments': {
      id: '/_authenticated/setup/departments'
      path: '/departments'
      fullPath: '/setup/departments'
      preLoaderRoute: typeof AuthenticatedSetupDepartmentsRouteImport
      parentRoute: typeof AuthenticatedSetupRoute
    }
    '/_authenticated/setup/custom-fields': {
      id: '/_authenticated/setup/custom-fields'
      path: '/custom-fields'
      fullPath: '/setup/custom-fields'
      preLoaderRoute: typeof AuthenticatedSetupCustomFieldsRouteImport
      parentRoute: typeof AuthenticatedSetupRoute
    }
    '/_authenticated/setup/company': {
      id: '/_authenticated/setup/company'
      path: '/company'
      fullPath: '/setup/company'
      preLoaderRoute: typeof AuthenticatedSetupCompanyRouteImport
      parentRoute: typeof AuthenticatedSetupRoute
    }
    '/_authenticated/setup/chart-of-accounts': {
      id: '/_authenticated/setup/chart-of-accounts'
      path: '/chart-of-accounts'
      fullPath: '/setup/chart-of-accounts'
      preLoaderRoute: typeof AuthenticatedSetupChartOfAccountsRouteImport
      parentRoute: typeof AuthenticatedSetupRoute
    }
    '/_authenticated/setup/business-units': {
      id: '/_authenticated/setup/business-units'
      path: '/business-units'
      fullPath: '/setup/business-units'
      preLoaderRoute: typeof AuthenticatedSetupBusinessUnitsRouteImport
      parentRoute: typeof AuthenticatedSetupRoute
    }
    '/_authenticated/setup/activities': {
      id: '/_authenticated/setup/activities'
      path: '/activities'
      fullPath: '/setup/activities'
      preLoaderRoute: typeof AuthenticatedSetupActivitiesRouteImport
      parentRoute: typeof AuthenticatedSetupRoute
    }
    '/_authenticated/reports/timesheets': {
      id: '/_authenticated/reports/timesheets'
      path: '/timesheets'
      fullPath: '/reports/timesheets'
      preLoaderRoute: typeof AuthenticatedReportsTimesheetsRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/new': {
      id: '/_authenticated/reports/new'
      path: '/new'
      fullPath: '/reports/new'
      preLoaderRoute: typeof AuthenticatedReportsNewRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/notifications/$id': {
      id: '/_authenticated/notifications/$id'
      path: '/notifications/$id'
      fullPath: '/notifications/$id'
      preLoaderRoute: typeof AuthenticatedNotificationsIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/invoices/variable-expenses': {
      id: '/_authenticated/invoices/variable-expenses'
      path: '/variable-expenses'
      fullPath: '/invoices/variable-expenses'
      preLoaderRoute: typeof AuthenticatedInvoicesVariableExpensesRouteImport
      parentRoute: typeof AuthenticatedInvoicesRoute
    }
    '/_authenticated/invoices/settings': {
      id: '/_authenticated/invoices/settings'
      path: '/settings'
      fullPath: '/invoices/settings'
      preLoaderRoute: typeof AuthenticatedInvoicesSettingsRouteImport
      parentRoute: typeof AuthenticatedInvoicesRoute
    }
    '/_authenticated/invoices/new': {
      id: '/_authenticated/invoices/new'
      path: '/new'
      fullPath: '/invoices/new'
      preLoaderRoute: typeof AuthenticatedInvoicesNewRouteImport
      parentRoute: typeof AuthenticatedInvoicesRoute
    }
    '/_authenticated/invoices/$id': {
      id: '/_authenticated/invoices/$id'
      path: '/$id'
      fullPath: '/invoices/$id'
      preLoaderRoute: typeof AuthenticatedInvoicesIdRouteImport
      parentRoute: typeof AuthenticatedInvoicesRoute
    }
    '/_authenticated/dashboards/$dashboardId': {
      id: '/_authenticated/dashboards/$dashboardId'
      path: '/$dashboardId'
      fullPath: '/dashboards/$dashboardId'
      preLoaderRoute: typeof AuthenticatedDashboardsDashboardIdRouteImport
      parentRoute: typeof AuthenticatedDashboardsRoute
    }
    '/_authenticated/dashboard/$dashboardId': {
      id: '/_authenticated/dashboard/$dashboardId'
      path: '/$dashboardId'
      fullPath: '/dashboard/$dashboardId'
      preLoaderRoute: typeof AuthenticatedDashboardDashboardIdRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/customers/$id': {
      id: '/_authenticated/customers/$id'
      path: '/$id'
      fullPath: '/customers/$id'
      preLoaderRoute: typeof AuthenticatedCustomersIdRouteImport
      parentRoute: typeof AuthenticatedCustomersRoute
    }
    '/_authenticated/users/$id/': {
      id: '/_authenticated/users/$id/'
      path: '/'
      fullPath: '/users/$id/'
      preLoaderRoute: typeof AuthenticatedUsersIdIndexRouteImport
      parentRoute: typeof AuthenticatedUsersIdRoute
    }
    '/_authenticated/setup/system-roles/': {
      id: '/_authenticated/setup/system-roles/'
      path: '/'
      fullPath: '/setup/system-roles/'
      preLoaderRoute: typeof AuthenticatedSetupSystemRolesIndexRouteImport
      parentRoute: typeof AuthenticatedSetupSystemRolesRoute
    }
    '/_authenticated/setup/service-roles/': {
      id: '/_authenticated/setup/service-roles/'
      path: '/'
      fullPath: '/setup/service-roles/'
      preLoaderRoute: typeof AuthenticatedSetupServiceRolesIndexRouteImport
      parentRoute: typeof AuthenticatedSetupServiceRolesRoute
    }
    '/_authenticated/setup/ratecards/': {
      id: '/_authenticated/setup/ratecards/'
      path: '/'
      fullPath: '/setup/ratecards/'
      preLoaderRoute: typeof AuthenticatedSetupRatecardsIndexRouteImport
      parentRoute: typeof AuthenticatedSetupRatecardsRoute
    }
    '/_authenticated/setup/expense-catalogs/': {
      id: '/_authenticated/setup/expense-catalogs/'
      path: '/'
      fullPath: '/setup/expense-catalogs/'
      preLoaderRoute: typeof AuthenticatedSetupExpenseCatalogsIndexRouteImport
      parentRoute: typeof AuthenticatedSetupExpenseCatalogsRoute
    }
    '/_authenticated/setup/departments/': {
      id: '/_authenticated/setup/departments/'
      path: '/'
      fullPath: '/setup/departments/'
      preLoaderRoute: typeof AuthenticatedSetupDepartmentsIndexRouteImport
      parentRoute: typeof AuthenticatedSetupDepartmentsRoute
    }
    '/_authenticated/setup/business-units/': {
      id: '/_authenticated/setup/business-units/'
      path: '/'
      fullPath: '/setup/business-units/'
      preLoaderRoute: typeof AuthenticatedSetupBusinessUnitsIndexRouteImport
      parentRoute: typeof AuthenticatedSetupBusinessUnitsRoute
    }
    '/_authenticated/setup/approval-policies/': {
      id: '/_authenticated/setup/approval-policies/'
      path: '/approval-policies'
      fullPath: '/setup/approval-policies/'
      preLoaderRoute: typeof AuthenticatedSetupApprovalPoliciesIndexRouteImport
      parentRoute: typeof AuthenticatedSetupRoute
    }
    '/_authenticated/setup/activities/': {
      id: '/_authenticated/setup/activities/'
      path: '/'
      fullPath: '/setup/activities/'
      preLoaderRoute: typeof AuthenticatedSetupActivitiesIndexRouteImport
      parentRoute: typeof AuthenticatedSetupActivitiesRoute
    }
    '/_authenticated/invoices/runs/': {
      id: '/_authenticated/invoices/runs/'
      path: '/runs'
      fullPath: '/invoices/runs/'
      preLoaderRoute: typeof AuthenticatedInvoicesRunsIndexRouteImport
      parentRoute: typeof AuthenticatedInvoicesRoute
    }
    '/_authenticated/customers/$id/': {
      id: '/_authenticated/customers/$id/'
      path: '/'
      fullPath: '/customers/$id/'
      preLoaderRoute: typeof AuthenticatedCustomersIdIndexRouteImport
      parentRoute: typeof AuthenticatedCustomersIdRoute
    }
    '/_authenticated/users/$id/edit': {
      id: '/_authenticated/users/$id/edit'
      path: '/edit'
      fullPath: '/users/$id/edit'
      preLoaderRoute: typeof AuthenticatedUsersIdEditRouteImport
      parentRoute: typeof AuthenticatedUsersIdRoute
    }
    '/_authenticated/setup/system-roles/$id': {
      id: '/_authenticated/setup/system-roles/$id'
      path: '/$id'
      fullPath: '/setup/system-roles/$id'
      preLoaderRoute: typeof AuthenticatedSetupSystemRolesIdRouteImport
      parentRoute: typeof AuthenticatedSetupSystemRolesRoute
    }
    '/_authenticated/setup/ratecards/$id': {
      id: '/_authenticated/setup/ratecards/$id'
      path: '/$id'
      fullPath: '/setup/ratecards/$id'
      preLoaderRoute: typeof AuthenticatedSetupRatecardsIdRouteImport
      parentRoute: typeof AuthenticatedSetupRatecardsRoute
    }
    '/_authenticated/setup/expense-catalogs/$id': {
      id: '/_authenticated/setup/expense-catalogs/$id'
      path: '/$id'
      fullPath: '/setup/expense-catalogs/$id'
      preLoaderRoute: typeof AuthenticatedSetupExpenseCatalogsIdRouteImport
      parentRoute: typeof AuthenticatedSetupExpenseCatalogsRoute
    }
    '/_authenticated/setup/departments/$id': {
      id: '/_authenticated/setup/departments/$id'
      path: '/$id'
      fullPath: '/setup/departments/$id'
      preLoaderRoute: typeof AuthenticatedSetupDepartmentsIdRouteImport
      parentRoute: typeof AuthenticatedSetupDepartmentsRoute
    }
    '/_authenticated/setup/business-units/$id': {
      id: '/_authenticated/setup/business-units/$id'
      path: '/$id'
      fullPath: '/setup/business-units/$id'
      preLoaderRoute: typeof AuthenticatedSetupBusinessUnitsIdRouteImport
      parentRoute: typeof AuthenticatedSetupBusinessUnitsRoute
    }
    '/_authenticated/setup/activities/$id': {
      id: '/_authenticated/setup/activities/$id'
      path: '/$id'
      fullPath: '/setup/activities/$id'
      preLoaderRoute: typeof AuthenticatedSetupActivitiesIdRouteImport
      parentRoute: typeof AuthenticatedSetupActivitiesRoute
    }
    '/_authenticated/reports/custom/$reportId': {
      id: '/_authenticated/reports/custom/$reportId'
      path: '/custom/$reportId'
      fullPath: '/reports/custom/$reportId'
      preLoaderRoute: typeof AuthenticatedReportsCustomReportIdRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/invoices/runs/$runId': {
      id: '/_authenticated/invoices/runs/$runId'
      path: '/runs/$runId'
      fullPath: '/invoices/runs/$runId'
      preLoaderRoute: typeof AuthenticatedInvoicesRunsRunIdRouteImport
      parentRoute: typeof AuthenticatedInvoicesRoute
    }
    '/_authenticated/customers/$id/edit': {
      id: '/_authenticated/customers/$id/edit'
      path: '/edit'
      fullPath: '/customers/$id/edit'
      preLoaderRoute: typeof AuthenticatedCustomersIdEditRouteImport
      parentRoute: typeof AuthenticatedCustomersIdRoute
    }
    '/_authenticated/setup/system-roles/$id/': {
      id: '/_authenticated/setup/system-roles/$id/'
      path: '/'
      fullPath: '/setup/system-roles/$id/'
      preLoaderRoute: typeof AuthenticatedSetupSystemRolesIdIndexRouteImport
      parentRoute: typeof AuthenticatedSetupSystemRolesIdRoute
    }
    '/_authenticated/setup/service-roles/$id/': {
      id: '/_authenticated/setup/service-roles/$id/'
      path: '/$id'
      fullPath: '/setup/service-roles/$id/'
      preLoaderRoute: typeof AuthenticatedSetupServiceRolesIdIndexRouteImport
      parentRoute: typeof AuthenticatedSetupServiceRolesRoute
    }
    '/_authenticated/setup/expense-catalogs/$id/': {
      id: '/_authenticated/setup/expense-catalogs/$id/'
      path: '/'
      fullPath: '/setup/expense-catalogs/$id/'
      preLoaderRoute: typeof AuthenticatedSetupExpenseCatalogsIdIndexRouteImport
      parentRoute: typeof AuthenticatedSetupExpenseCatalogsIdRoute
    }
    '/_authenticated/setup/departments/$id/': {
      id: '/_authenticated/setup/departments/$id/'
      path: '/'
      fullPath: '/setup/departments/$id/'
      preLoaderRoute: typeof AuthenticatedSetupDepartmentsIdIndexRouteImport
      parentRoute: typeof AuthenticatedSetupDepartmentsIdRoute
    }
    '/_authenticated/setup/activities/$id/': {
      id: '/_authenticated/setup/activities/$id/'
      path: '/'
      fullPath: '/setup/activities/$id/'
      preLoaderRoute: typeof AuthenticatedSetupActivitiesIdIndexRouteImport
      parentRoute: typeof AuthenticatedSetupActivitiesIdRoute
    }
    '/_authenticated/customers/$id/sows/$sowId': {
      id: '/_authenticated/customers/$id/sows/$sowId'
      path: '/sows/$sowId'
      fullPath: '/customers/$id/sows/$sowId'
      preLoaderRoute: typeof AuthenticatedCustomersIdSowsSowIdRouteImport
      parentRoute: typeof AuthenticatedCustomersIdRoute
    }
    '/_authenticated/customers/$id/engagements/$engagementId': {
      id: '/_authenticated/customers/$id/engagements/$engagementId'
      path: '/engagements/$engagementId'
      fullPath: '/customers/$id/engagements/$engagementId'
      preLoaderRoute: typeof AuthenticatedCustomersIdEngagementsEngagementIdRouteImport
      parentRoute: typeof AuthenticatedCustomersIdRoute
    }
  }
}

interface AuthenticatedCustomersIdRouteChildren {
  AuthenticatedCustomersIdEditRoute: typeof AuthenticatedCustomersIdEditRoute
  AuthenticatedCustomersIdIndexRoute: typeof AuthenticatedCustomersIdIndexRoute
  AuthenticatedCustomersIdEngagementsEngagementIdRoute: typeof AuthenticatedCustomersIdEngagementsEngagementIdRoute
  AuthenticatedCustomersIdSowsSowIdRoute: typeof AuthenticatedCustomersIdSowsSowIdRoute
}

const AuthenticatedCustomersIdRouteChildren: AuthenticatedCustomersIdRouteChildren =
  {
    AuthenticatedCustomersIdEditRoute: AuthenticatedCustomersIdEditRoute,
    AuthenticatedCustomersIdIndexRoute: AuthenticatedCustomersIdIndexRoute,
    AuthenticatedCustomersIdEngagementsEngagementIdRoute:
      AuthenticatedCustomersIdEngagementsEngagementIdRoute,
    AuthenticatedCustomersIdSowsSowIdRoute:
      AuthenticatedCustomersIdSowsSowIdRoute,
  }

const AuthenticatedCustomersIdRouteWithChildren =
  AuthenticatedCustomersIdRoute._addFileChildren(
    AuthenticatedCustomersIdRouteChildren,
  )

interface AuthenticatedCustomersRouteChildren {
  AuthenticatedCustomersIdRoute: typeof AuthenticatedCustomersIdRouteWithChildren
  AuthenticatedCustomersIndexRoute: typeof AuthenticatedCustomersIndexRoute
}

const AuthenticatedCustomersRouteChildren: AuthenticatedCustomersRouteChildren =
  {
    AuthenticatedCustomersIdRoute: AuthenticatedCustomersIdRouteWithChildren,
    AuthenticatedCustomersIndexRoute: AuthenticatedCustomersIndexRoute,
  }

const AuthenticatedCustomersRouteWithChildren =
  AuthenticatedCustomersRoute._addFileChildren(
    AuthenticatedCustomersRouteChildren,
  )

interface AuthenticatedDashboardRouteChildren {
  AuthenticatedDashboardDashboardIdRoute: typeof AuthenticatedDashboardDashboardIdRoute
  AuthenticatedDashboardIndexRoute: typeof AuthenticatedDashboardIndexRoute
}

const AuthenticatedDashboardRouteChildren: AuthenticatedDashboardRouteChildren =
  {
    AuthenticatedDashboardDashboardIdRoute:
      AuthenticatedDashboardDashboardIdRoute,
    AuthenticatedDashboardIndexRoute: AuthenticatedDashboardIndexRoute,
  }

const AuthenticatedDashboardRouteWithChildren =
  AuthenticatedDashboardRoute._addFileChildren(
    AuthenticatedDashboardRouteChildren,
  )

interface AuthenticatedDashboardsRouteChildren {
  AuthenticatedDashboardsDashboardIdRoute: typeof AuthenticatedDashboardsDashboardIdRoute
  AuthenticatedDashboardsIndexRoute: typeof AuthenticatedDashboardsIndexRoute
}

const AuthenticatedDashboardsRouteChildren: AuthenticatedDashboardsRouteChildren =
  {
    AuthenticatedDashboardsDashboardIdRoute:
      AuthenticatedDashboardsDashboardIdRoute,
    AuthenticatedDashboardsIndexRoute: AuthenticatedDashboardsIndexRoute,
  }

const AuthenticatedDashboardsRouteWithChildren =
  AuthenticatedDashboardsRoute._addFileChildren(
    AuthenticatedDashboardsRouteChildren,
  )

interface AuthenticatedInvoicesRouteChildren {
  AuthenticatedInvoicesIdRoute: typeof AuthenticatedInvoicesIdRoute
  AuthenticatedInvoicesNewRoute: typeof AuthenticatedInvoicesNewRoute
  AuthenticatedInvoicesSettingsRoute: typeof AuthenticatedInvoicesSettingsRoute
  AuthenticatedInvoicesVariableExpensesRoute: typeof AuthenticatedInvoicesVariableExpensesRoute
  AuthenticatedInvoicesIndexRoute: typeof AuthenticatedInvoicesIndexRoute
  AuthenticatedInvoicesRunsRunIdRoute: typeof AuthenticatedInvoicesRunsRunIdRoute
  AuthenticatedInvoicesRunsIndexRoute: typeof AuthenticatedInvoicesRunsIndexRoute
}

const AuthenticatedInvoicesRouteChildren: AuthenticatedInvoicesRouteChildren = {
  AuthenticatedInvoicesIdRoute: AuthenticatedInvoicesIdRoute,
  AuthenticatedInvoicesNewRoute: AuthenticatedInvoicesNewRoute,
  AuthenticatedInvoicesSettingsRoute: AuthenticatedInvoicesSettingsRoute,
  AuthenticatedInvoicesVariableExpensesRoute:
    AuthenticatedInvoicesVariableExpensesRoute,
  AuthenticatedInvoicesIndexRoute: AuthenticatedInvoicesIndexRoute,
  AuthenticatedInvoicesRunsRunIdRoute: AuthenticatedInvoicesRunsRunIdRoute,
  AuthenticatedInvoicesRunsIndexRoute: AuthenticatedInvoicesRunsIndexRoute,
}

const AuthenticatedInvoicesRouteWithChildren =
  AuthenticatedInvoicesRoute._addFileChildren(
    AuthenticatedInvoicesRouteChildren,
  )

interface AuthenticatedReportsRouteChildren {
  AuthenticatedReportsNewRoute: typeof AuthenticatedReportsNewRoute
  AuthenticatedReportsTimesheetsRoute: typeof AuthenticatedReportsTimesheetsRoute
  AuthenticatedReportsIndexRoute: typeof AuthenticatedReportsIndexRoute
  AuthenticatedReportsCustomReportIdRoute: typeof AuthenticatedReportsCustomReportIdRoute
}

const AuthenticatedReportsRouteChildren: AuthenticatedReportsRouteChildren = {
  AuthenticatedReportsNewRoute: AuthenticatedReportsNewRoute,
  AuthenticatedReportsTimesheetsRoute: AuthenticatedReportsTimesheetsRoute,
  AuthenticatedReportsIndexRoute: AuthenticatedReportsIndexRoute,
  AuthenticatedReportsCustomReportIdRoute:
    AuthenticatedReportsCustomReportIdRoute,
}

const AuthenticatedReportsRouteWithChildren =
  AuthenticatedReportsRoute._addFileChildren(AuthenticatedReportsRouteChildren)

interface AuthenticatedSetupActivitiesIdRouteChildren {
  AuthenticatedSetupActivitiesIdIndexRoute: typeof AuthenticatedSetupActivitiesIdIndexRoute
}

const AuthenticatedSetupActivitiesIdRouteChildren: AuthenticatedSetupActivitiesIdRouteChildren =
  {
    AuthenticatedSetupActivitiesIdIndexRoute:
      AuthenticatedSetupActivitiesIdIndexRoute,
  }

const AuthenticatedSetupActivitiesIdRouteWithChildren =
  AuthenticatedSetupActivitiesIdRoute._addFileChildren(
    AuthenticatedSetupActivitiesIdRouteChildren,
  )

interface AuthenticatedSetupActivitiesRouteChildren {
  AuthenticatedSetupActivitiesIdRoute: typeof AuthenticatedSetupActivitiesIdRouteWithChildren
  AuthenticatedSetupActivitiesIndexRoute: typeof AuthenticatedSetupActivitiesIndexRoute
}

const AuthenticatedSetupActivitiesRouteChildren: AuthenticatedSetupActivitiesRouteChildren =
  {
    AuthenticatedSetupActivitiesIdRoute:
      AuthenticatedSetupActivitiesIdRouteWithChildren,
    AuthenticatedSetupActivitiesIndexRoute:
      AuthenticatedSetupActivitiesIndexRoute,
  }

const AuthenticatedSetupActivitiesRouteWithChildren =
  AuthenticatedSetupActivitiesRoute._addFileChildren(
    AuthenticatedSetupActivitiesRouteChildren,
  )

interface AuthenticatedSetupBusinessUnitsRouteChildren {
  AuthenticatedSetupBusinessUnitsIdRoute: typeof AuthenticatedSetupBusinessUnitsIdRoute
  AuthenticatedSetupBusinessUnitsIndexRoute: typeof AuthenticatedSetupBusinessUnitsIndexRoute
}

const AuthenticatedSetupBusinessUnitsRouteChildren: AuthenticatedSetupBusinessUnitsRouteChildren =
  {
    AuthenticatedSetupBusinessUnitsIdRoute:
      AuthenticatedSetupBusinessUnitsIdRoute,
    AuthenticatedSetupBusinessUnitsIndexRoute:
      AuthenticatedSetupBusinessUnitsIndexRoute,
  }

const AuthenticatedSetupBusinessUnitsRouteWithChildren =
  AuthenticatedSetupBusinessUnitsRoute._addFileChildren(
    AuthenticatedSetupBusinessUnitsRouteChildren,
  )

interface AuthenticatedSetupDepartmentsIdRouteChildren {
  AuthenticatedSetupDepartmentsIdIndexRoute: typeof AuthenticatedSetupDepartmentsIdIndexRoute
}

const AuthenticatedSetupDepartmentsIdRouteChildren: AuthenticatedSetupDepartmentsIdRouteChildren =
  {
    AuthenticatedSetupDepartmentsIdIndexRoute:
      AuthenticatedSetupDepartmentsIdIndexRoute,
  }

const AuthenticatedSetupDepartmentsIdRouteWithChildren =
  AuthenticatedSetupDepartmentsIdRoute._addFileChildren(
    AuthenticatedSetupDepartmentsIdRouteChildren,
  )

interface AuthenticatedSetupDepartmentsRouteChildren {
  AuthenticatedSetupDepartmentsIdRoute: typeof AuthenticatedSetupDepartmentsIdRouteWithChildren
  AuthenticatedSetupDepartmentsIndexRoute: typeof AuthenticatedSetupDepartmentsIndexRoute
}

const AuthenticatedSetupDepartmentsRouteChildren: AuthenticatedSetupDepartmentsRouteChildren =
  {
    AuthenticatedSetupDepartmentsIdRoute:
      AuthenticatedSetupDepartmentsIdRouteWithChildren,
    AuthenticatedSetupDepartmentsIndexRoute:
      AuthenticatedSetupDepartmentsIndexRoute,
  }

const AuthenticatedSetupDepartmentsRouteWithChildren =
  AuthenticatedSetupDepartmentsRoute._addFileChildren(
    AuthenticatedSetupDepartmentsRouteChildren,
  )

interface AuthenticatedSetupExpenseCatalogsIdRouteChildren {
  AuthenticatedSetupExpenseCatalogsIdIndexRoute: typeof AuthenticatedSetupExpenseCatalogsIdIndexRoute
}

const AuthenticatedSetupExpenseCatalogsIdRouteChildren: AuthenticatedSetupExpenseCatalogsIdRouteChildren =
  {
    AuthenticatedSetupExpenseCatalogsIdIndexRoute:
      AuthenticatedSetupExpenseCatalogsIdIndexRoute,
  }

const AuthenticatedSetupExpenseCatalogsIdRouteWithChildren =
  AuthenticatedSetupExpenseCatalogsIdRoute._addFileChildren(
    AuthenticatedSetupExpenseCatalogsIdRouteChildren,
  )

interface AuthenticatedSetupExpenseCatalogsRouteChildren {
  AuthenticatedSetupExpenseCatalogsIdRoute: typeof AuthenticatedSetupExpenseCatalogsIdRouteWithChildren
  AuthenticatedSetupExpenseCatalogsIndexRoute: typeof AuthenticatedSetupExpenseCatalogsIndexRoute
}

const AuthenticatedSetupExpenseCatalogsRouteChildren: AuthenticatedSetupExpenseCatalogsRouteChildren =
  {
    AuthenticatedSetupExpenseCatalogsIdRoute:
      AuthenticatedSetupExpenseCatalogsIdRouteWithChildren,
    AuthenticatedSetupExpenseCatalogsIndexRoute:
      AuthenticatedSetupExpenseCatalogsIndexRoute,
  }

const AuthenticatedSetupExpenseCatalogsRouteWithChildren =
  AuthenticatedSetupExpenseCatalogsRoute._addFileChildren(
    AuthenticatedSetupExpenseCatalogsRouteChildren,
  )

interface AuthenticatedSetupRatecardsRouteChildren {
  AuthenticatedSetupRatecardsIdRoute: typeof AuthenticatedSetupRatecardsIdRoute
  AuthenticatedSetupRatecardsIndexRoute: typeof AuthenticatedSetupRatecardsIndexRoute
}

const AuthenticatedSetupRatecardsRouteChildren: AuthenticatedSetupRatecardsRouteChildren =
  {
    AuthenticatedSetupRatecardsIdRoute: AuthenticatedSetupRatecardsIdRoute,
    AuthenticatedSetupRatecardsIndexRoute:
      AuthenticatedSetupRatecardsIndexRoute,
  }

const AuthenticatedSetupRatecardsRouteWithChildren =
  AuthenticatedSetupRatecardsRoute._addFileChildren(
    AuthenticatedSetupRatecardsRouteChildren,
  )

interface AuthenticatedSetupServiceRolesRouteChildren {
  AuthenticatedSetupServiceRolesIndexRoute: typeof AuthenticatedSetupServiceRolesIndexRoute
  AuthenticatedSetupServiceRolesIdIndexRoute: typeof AuthenticatedSetupServiceRolesIdIndexRoute
}

const AuthenticatedSetupServiceRolesRouteChildren: AuthenticatedSetupServiceRolesRouteChildren =
  {
    AuthenticatedSetupServiceRolesIndexRoute:
      AuthenticatedSetupServiceRolesIndexRoute,
    AuthenticatedSetupServiceRolesIdIndexRoute:
      AuthenticatedSetupServiceRolesIdIndexRoute,
  }

const AuthenticatedSetupServiceRolesRouteWithChildren =
  AuthenticatedSetupServiceRolesRoute._addFileChildren(
    AuthenticatedSetupServiceRolesRouteChildren,
  )

interface AuthenticatedSetupSystemRolesIdRouteChildren {
  AuthenticatedSetupSystemRolesIdIndexRoute: typeof AuthenticatedSetupSystemRolesIdIndexRoute
}

const AuthenticatedSetupSystemRolesIdRouteChildren: AuthenticatedSetupSystemRolesIdRouteChildren =
  {
    AuthenticatedSetupSystemRolesIdIndexRoute:
      AuthenticatedSetupSystemRolesIdIndexRoute,
  }

const AuthenticatedSetupSystemRolesIdRouteWithChildren =
  AuthenticatedSetupSystemRolesIdRoute._addFileChildren(
    AuthenticatedSetupSystemRolesIdRouteChildren,
  )

interface AuthenticatedSetupSystemRolesRouteChildren {
  AuthenticatedSetupSystemRolesIdRoute: typeof AuthenticatedSetupSystemRolesIdRouteWithChildren
  AuthenticatedSetupSystemRolesIndexRoute: typeof AuthenticatedSetupSystemRolesIndexRoute
}

const AuthenticatedSetupSystemRolesRouteChildren: AuthenticatedSetupSystemRolesRouteChildren =
  {
    AuthenticatedSetupSystemRolesIdRoute:
      AuthenticatedSetupSystemRolesIdRouteWithChildren,
    AuthenticatedSetupSystemRolesIndexRoute:
      AuthenticatedSetupSystemRolesIndexRoute,
  }

const AuthenticatedSetupSystemRolesRouteWithChildren =
  AuthenticatedSetupSystemRolesRoute._addFileChildren(
    AuthenticatedSetupSystemRolesRouteChildren,
  )

interface AuthenticatedSetupRouteChildren {
  AuthenticatedSetupActivitiesRoute: typeof AuthenticatedSetupActivitiesRouteWithChildren
  AuthenticatedSetupBusinessUnitsRoute: typeof AuthenticatedSetupBusinessUnitsRouteWithChildren
  AuthenticatedSetupChartOfAccountsRoute: typeof AuthenticatedSetupChartOfAccountsRoute
  AuthenticatedSetupCompanyRoute: typeof AuthenticatedSetupCompanyRoute
  AuthenticatedSetupCustomFieldsRoute: typeof AuthenticatedSetupCustomFieldsRoute
  AuthenticatedSetupDepartmentsRoute: typeof AuthenticatedSetupDepartmentsRouteWithChildren
  AuthenticatedSetupExpenseCatalogsRoute: typeof AuthenticatedSetupExpenseCatalogsRouteWithChildren
  AuthenticatedSetupHolidaysRoute: typeof AuthenticatedSetupHolidaysRoute
  AuthenticatedSetupNotificationsRoute: typeof AuthenticatedSetupNotificationsRoute
  AuthenticatedSetupRatecardsRoute: typeof AuthenticatedSetupRatecardsRouteWithChildren
  AuthenticatedSetupServiceRolesRoute: typeof AuthenticatedSetupServiceRolesRouteWithChildren
  AuthenticatedSetupSkillsRoute: typeof AuthenticatedSetupSkillsRoute
  AuthenticatedSetupSystemRolesRoute: typeof AuthenticatedSetupSystemRolesRouteWithChildren
  AuthenticatedSetupIndexRoute: typeof AuthenticatedSetupIndexRoute
  AuthenticatedSetupApprovalPoliciesIndexRoute: typeof AuthenticatedSetupApprovalPoliciesIndexRoute
}

const AuthenticatedSetupRouteChildren: AuthenticatedSetupRouteChildren = {
  AuthenticatedSetupActivitiesRoute:
    AuthenticatedSetupActivitiesRouteWithChildren,
  AuthenticatedSetupBusinessUnitsRoute:
    AuthenticatedSetupBusinessUnitsRouteWithChildren,
  AuthenticatedSetupChartOfAccountsRoute:
    AuthenticatedSetupChartOfAccountsRoute,
  AuthenticatedSetupCompanyRoute: AuthenticatedSetupCompanyRoute,
  AuthenticatedSetupCustomFieldsRoute: AuthenticatedSetupCustomFieldsRoute,
  AuthenticatedSetupDepartmentsRoute:
    AuthenticatedSetupDepartmentsRouteWithChildren,
  AuthenticatedSetupExpenseCatalogsRoute:
    AuthenticatedSetupExpenseCatalogsRouteWithChildren,
  AuthenticatedSetupHolidaysRoute: AuthenticatedSetupHolidaysRoute,
  AuthenticatedSetupNotificationsRoute: AuthenticatedSetupNotificationsRoute,
  AuthenticatedSetupRatecardsRoute:
    AuthenticatedSetupRatecardsRouteWithChildren,
  AuthenticatedSetupServiceRolesRoute:
    AuthenticatedSetupServiceRolesRouteWithChildren,
  AuthenticatedSetupSkillsRoute: AuthenticatedSetupSkillsRoute,
  AuthenticatedSetupSystemRolesRoute:
    AuthenticatedSetupSystemRolesRouteWithChildren,
  AuthenticatedSetupIndexRoute: AuthenticatedSetupIndexRoute,
  AuthenticatedSetupApprovalPoliciesIndexRoute:
    AuthenticatedSetupApprovalPoliciesIndexRoute,
}

const AuthenticatedSetupRouteWithChildren =
  AuthenticatedSetupRoute._addFileChildren(AuthenticatedSetupRouteChildren)

interface AuthenticatedTimesheetsRouteChildren {
  AuthenticatedTimesheetsSettingsRoute: typeof AuthenticatedTimesheetsSettingsRoute
  AuthenticatedTimesheetsIndexRoute: typeof AuthenticatedTimesheetsIndexRoute
}

const AuthenticatedTimesheetsRouteChildren: AuthenticatedTimesheetsRouteChildren =
  {
    AuthenticatedTimesheetsSettingsRoute: AuthenticatedTimesheetsSettingsRoute,
    AuthenticatedTimesheetsIndexRoute: AuthenticatedTimesheetsIndexRoute,
  }

const AuthenticatedTimesheetsRouteWithChildren =
  AuthenticatedTimesheetsRoute._addFileChildren(
    AuthenticatedTimesheetsRouteChildren,
  )

interface AuthenticatedUsersIdRouteChildren {
  AuthenticatedUsersIdEditRoute: typeof AuthenticatedUsersIdEditRoute
  AuthenticatedUsersIdIndexRoute: typeof AuthenticatedUsersIdIndexRoute
}

const AuthenticatedUsersIdRouteChildren: AuthenticatedUsersIdRouteChildren = {
  AuthenticatedUsersIdEditRoute: AuthenticatedUsersIdEditRoute,
  AuthenticatedUsersIdIndexRoute: AuthenticatedUsersIdIndexRoute,
}

const AuthenticatedUsersIdRouteWithChildren =
  AuthenticatedUsersIdRoute._addFileChildren(AuthenticatedUsersIdRouteChildren)

interface AuthenticatedUsersRouteChildren {
  AuthenticatedUsersIdRoute: typeof AuthenticatedUsersIdRouteWithChildren
  AuthenticatedUsersNewRoute: typeof AuthenticatedUsersNewRoute
  AuthenticatedUsersIndexRoute: typeof AuthenticatedUsersIndexRoute
}

const AuthenticatedUsersRouteChildren: AuthenticatedUsersRouteChildren = {
  AuthenticatedUsersIdRoute: AuthenticatedUsersIdRouteWithChildren,
  AuthenticatedUsersNewRoute: AuthenticatedUsersNewRoute,
  AuthenticatedUsersIndexRoute: AuthenticatedUsersIndexRoute,
}

const AuthenticatedUsersRouteWithChildren =
  AuthenticatedUsersRoute._addFileChildren(AuthenticatedUsersRouteChildren)

interface AuthenticatedRouteChildren {
  AuthenticatedApprovalsRoute: typeof AuthenticatedApprovalsRoute
  AuthenticatedAuditRoute: typeof AuthenticatedAuditRoute
  AuthenticatedCustomersRoute: typeof AuthenticatedCustomersRouteWithChildren
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRouteWithChildren
  AuthenticatedDashboardsRoute: typeof AuthenticatedDashboardsRouteWithChildren
  AuthenticatedGuidesAndUpdatesRoute: typeof AuthenticatedGuidesAndUpdatesRoute
  AuthenticatedInvoicesRoute: typeof AuthenticatedInvoicesRouteWithChildren
  AuthenticatedReportsRoute: typeof AuthenticatedReportsRouteWithChildren
  AuthenticatedSetupRoute: typeof AuthenticatedSetupRouteWithChildren
  AuthenticatedTimesheetsRoute: typeof AuthenticatedTimesheetsRouteWithChildren
  AuthenticatedUsersRoute: typeof AuthenticatedUsersRouteWithChildren
  AuthenticatedNotificationsIdRoute: typeof AuthenticatedNotificationsIdRoute
  AuthenticatedNotificationsIndexRoute: typeof AuthenticatedNotificationsIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedApprovalsRoute: AuthenticatedApprovalsRoute,
  AuthenticatedAuditRoute: AuthenticatedAuditRoute,
  AuthenticatedCustomersRoute: AuthenticatedCustomersRouteWithChildren,
  AuthenticatedDashboardRoute: AuthenticatedDashboardRouteWithChildren,
  AuthenticatedDashboardsRoute: AuthenticatedDashboardsRouteWithChildren,
  AuthenticatedGuidesAndUpdatesRoute: AuthenticatedGuidesAndUpdatesRoute,
  AuthenticatedInvoicesRoute: AuthenticatedInvoicesRouteWithChildren,
  AuthenticatedReportsRoute: AuthenticatedReportsRouteWithChildren,
  AuthenticatedSetupRoute: AuthenticatedSetupRouteWithChildren,
  AuthenticatedTimesheetsRoute: AuthenticatedTimesheetsRouteWithChildren,
  AuthenticatedUsersRoute: AuthenticatedUsersRouteWithChildren,
  AuthenticatedNotificationsIdRoute: AuthenticatedNotificationsIdRoute,
  AuthenticatedNotificationsIndexRoute: AuthenticatedNotificationsIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
  NoAccessRoute: NoAccessRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
